// R39 — SAVE THIS READING TO MY ROOM: ONE CONTROL, THE ROW AND THE READING.
//
// W5-2 made this exact ruling for BOOKS — "the chip on all 98 spines, not only in the reader",
// because the capability living in the one reader that needed it first is why her own three books
// had none. Nobody had asked it of READINGS, which is the thing this house actually sells. Measured
// at R39: `listRoomShelf` puts `inMyRoom` on every shelf row and the CARD rendered none of it. To
// find out whether a reading was in My Room — or to put it there — she had to OPEN it, one at a
// time, down the whole shelf.
//
// Props in, tree out, no hook, which is the entry requirement for a gate to CALL it and read the
// tree back: the id on the element so a rendered walk can find the control for a named reading, the
// accessible name a screen reader hears, and the saved state on the class so a row can say so
// without a reload.
//
// `saved === null` is "we have not been told yet" — it holds still rather than claiming "not saved",
// which is R20/R18's distinction in a control: an answer that HAS NOT ARRIVED is not an answer.
import { myRoomButtonLabel, myRoomAriaLabel } from "../lib/saved-readings";

// "toolbar" wears the full sentence (there is room for one in a modal header). "row" is the chip
// beside a shelf card's title, where there is room for a mark and its accessible name only.
export type MyRoomVariant = "toolbar" | "row";

export function SaveReadingButton({ id, title, saved, onSave, variant = "toolbar", className }: {
  id: string;
  title: string;
  saved: boolean | null;
  onSave: (id: string) => void;
  variant?: MyRoomVariant;
  className?: string;
}) {
  const on = saved === true;
  const base = variant === "toolbar" ? "myroom-save" : "myroom-save myroom-save--row";
  return (
    <button
      type="button"
      data-save-reading={id}
      className={`${base}${on ? " is-saved" : ""}${className ? ` ${className}` : ""}`}
      aria-label={myRoomAriaLabel(title, on)}
      aria-pressed={on}
      title={myRoomButtonLabel(on)}
      // Already there is not a failure and not a thing to tap again: the control states the fact.
      disabled={saved === null || on}
      onClick={(event) => {
        // A chip that sits on a shelf card must not also open the reading it is sitting on.
        event.stopPropagation();
        event.preventDefault();
        onSave(id);
      }}
    >
      {variant === "toolbar" ? myRoomButtonLabel(on) : <span aria-hidden="true">{on ? "✓" : "＋"}</span>}
    </button>
  );
}
